<template>
<div class="chapter">
<div class="inner_page">
<p class="c3" id="calibre_pb_1"> <br class="calibre2"/></p>
<p class="c">A PERMUTED PRESS BOOK</p>
<p class="c">Published at Smashwords</p>
<p class="c"> <br class="calibre2"/></p>
<p class="c">ISBN: 978-1-61868-571-1</p>
<p class="c">ISBN (eBook): 978-1-61868-572-8</p>
<p class="c"> <br class="calibre2"/></p>
<p class="c">THE JOURNAL: CRIMSON SKIES</p>
<p class="c">Copyright © 2015 by Deborah D. Moore</p>
<p class="c">All Rights Reserved</p>
<p class="c"> <br class="calibre2"/></p>
<p class="c">Cover art by Matt Mosley</p>
<p class="c"> <br class="calibre2"/></p>
<p class="c">This book is a work of fiction. People, places,
events, and situations are the product of the author's imagination.
Any resemblance to actual persons, living or dead, or historical
events, is purely coincidental.</p>
<p class="c"> <br class="calibre2"/></p>
<p class="c">No part of this book may be reproduced, stored in a
retrieval system, or transmitted by any means without the written
permission of the author and publisher.</p>
<p class="c"> <br class="calibre2"/></p>
<p class="c">Smashwords Edition, License Notes</p>
<p class="c">This ebook is licensed for your personal enjoyment
only. This ebook may not be re-sold or given away to other people.
If you would like to share this book with another person, please
purchase an additional copy for each recipient. If you’re reading
this book and did not purchase it, or it was not purchased for your
use only, then please return to your favorite ebook retailer and
purchase your own copy. Thank you for respecting the hard work of
this author.</p>
<p class="c"> <br class="calibre2"/></p>
<p class="c"><img alt="tmp_648f5cba11b35594391da1bef1608eec_YkgYR9_html_7b83cc85.png" class="calibre3" id="graphics2" src="tmp_648f5cba11b35594391da1bef1608eec_YkgYR9_html_7b83cc85.png"/></p>
<p class="c"> <br class="calibre2"/></p>
<p class="c">Permuted Press</p>
<p class="c">109 International Drive, Suite 300</p>
<p class="c" lang="de-DE" xml:lang="de-DE">Franklin, TN 37067</p>
<p class="c4"><span class="c5"><a href="http://permutedpress.com/" target="_blank"><span lang="de-DE" xml:lang="de-DE">http://permutedpress.com</span></a></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tmp_648f5cba11b35594391da1bef1608eec_YkgYR9.ch.fixed.fc.tidied.stylehacked.xfixed_split_002.vue?44f10d48